import { defineStore } from "pinia";
import { ToastFailed } from "@/helper/services/toast";
import http from "../helper/services/http";

import useAuthStore from "./auth";
import { useUIStore } from "./ui";
import useUserStore from "./user";
import useDocumentStore from "./document";

export const useNotificationStore = defineStore("notification", {
  state: () => {
    return {
      notifications: [],
      lastFetchTime: {},
    };
  },
  getters: {
    isDataExpired: (state) => (key) => {
      if (!state.lastFetchTime[key]) {
        return true;
      }
      const expirationTime = new Date(
        state.lastFetchTime[key].getTime() + 60 * 60 * 1000
      );
      return expirationTime < new Date();
    },
  },
  actions: {
    loadNotification() {
      if (!this.isDataExpired("loadNotification")) {
        return;
      }
      useUIStore().setLoading(true);
      http({ path: "docs" })
        .get("notifications", {
          params: { user_id: useAuthStore().user.id, limit: 20 },
        })
        .then(async (res) => {
          let currentUserId = useAuthStore().user.id;

          let data = res.data.data.filter((item) => {
            let content = item.content.toLowerCase();
            let userMatch = item.user_id === currentUserId;

            let isUserSigning =
              content.includes("menandatangani") ||
              content.includes("berhasil ditandatangani secara elektronik oleh") ||
              content.includes("gagal ditandatangani secara elektronik oleh");

            if (userMatch && isUserSigning) {
              return false;
            }

            return true;
          });

          let user = data.reduce((uniqueIds, notification) => {
            const { user_id, receiver_id } = notification;

            if (receiver_id && !uniqueIds.includes(receiver_id)) {
              uniqueIds.push(receiver_id);
            }

            if (user_id && !uniqueIds.includes(user_id)) {
              uniqueIds.push(user_id);
            }

            return uniqueIds;
          }, []);

          user = await Promise.all(
            user.map(async (u) => {
              let name = await useUserStore().getSelectedUser(u, "name");
              return { id: u, user_name: name };
            })
          );

          data = await Promise.all(
            data.map(async (e) => {
              let user_name = user.find(
                (user) => user.id == e.user_id
              ).user_name;
              let receiver_name;
              if (e.receiver_id) {
                receiver_name = user.find(
                  (user) => user.id == e.receiver_id
                ).user_name;
              }

              return { ...e, user_name, receiver_name };
            })
          );

          this.notifications = data;
          useUIStore().setLoading(false);
          this.lastFetchTime["loadNotification"] = new Date();
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        );
    },
    createNotification({ documentID, content, recaiver_id = null }) {
      useUIStore().setLoading(true);
      let params = {
        user_id: useAuthStore().user.id,
        number: 1,
        label: useDocumentStore().detailFile.name,
        param: documentID,
        content,
      }

      if (recaiver_id) {
        params.receiver_id = recaiver_id;
      }

      http({ path: "docs" })
        .post("notifications/create", null, {
          params
        })
        .then((res) => {
          this.addNotication([res.data.data]);
        })
        .catch((err) => ToastFailed.fire({ icon: "error", title: err.message }))
        .finally(() => useUIStore().setLoading(false));
    },
    async addNotication(notification) {
      let user = notification.reduce((uniqueIds, notification) => {
        const { user_id } = notification;

        if (!uniqueIds.includes(user_id)) {
          uniqueIds.push(user_id);
        }

        return uniqueIds;
      }, []);

      user = await Promise.all(
        user.map(async (u) => {
          let name = await useUserStore().getSelectedUser(u, "name");
          return { id: u, user_name: name };
        })
      );

      notification = await Promise.all(
        notification.map(async (e) => {
          let user_name = user.find((user) => user.id == e.user_id).user_name;

          return { ...e, user_name };
        })
      );

      this.notifications.unshift(...notification);
      // if (this.notifications.length > 10) {
      this.notifications.pop();
      // }
    },
  },
});
